const DEFAULT_MAX_DUR = 1000;

export const RAF = (
  exec: (cb?: VoidFunction) => void,
  maxDur: number = DEFAULT_MAX_DUR,
): void => {
  let start: number | undefined = undefined;
  let timer: number;

  const step = (timestamp: number) => {
    if (start === undefined) {
      start = timestamp;
    }

    const elapsed = timestamp - start;

    if (elapsed < maxDur) {
      // Stop after two seconds
      timer = window.requestAnimationFrame(step);
      exec(() => {
        window.cancelAnimationFrame(timer);
      });
    } else {
      exec();
    }
  };

  timer = window.requestAnimationFrame(step);
};

export default RAF;
